import React from 'react';

const BlogCategoriesSection = ({ selectedCategory, onCategoryChange }) => {
  const categories = [
    'All',
    'Digital Marketing',
    'SEO Tips',
    'Web Development',
    'Design Trends'
  ];

  return (
    <section className="section-padding bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="d-flex flex-wrap justify-content-center gap-2" data-aos="fade-up">
              {categories.map((category) => (
                <button
                  key={category}
                  className={`btn ${selectedCategory === category ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => onCategoryChange(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogCategoriesSection;
